/* UNITO native app-motor — konfigurator, "Læs mere"-modals, galleri+zoom, 3D-visning,
   sammenligning og Shopify-kurv. Ren vanilla JS, 1:1-port af React-komponenterne. */
(function () {
  var U = window.UNITO;
  if (!U) return;
  var ASSETS = window.__UNITO_ASSETS || '/';

  /* ---------- helpers ---------- */
  var FN = {}; U.functions.forEach(function (f) { FN[f.id] = f; });
  var SPOUT_LABEL = { C: 'C-tud', U: 'U-tud', 'C-pullout': 'C-tud m. udtræk' };
  var COLOR_DOT = { Krom: '#D9D9D9', 'Stål': '#A9ABAE', Sort: '#1A1A1A', Gunmetal: '#3A4046', Guld: '#C6A26A', Rosa: '#E8A0B4' };

  function fmt(n) { if (n == null) return '—'; return n.toLocaleString('da-DK') + ' kr.'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(src) { if (!src) return ''; return src.indexOf('__ASSET__') === 0 ? ASSETS + src.slice(9) : src; }
  function hiRes(src) { return typeof src === 'string' ? src.replace(/-\d+x\d+(\.[a-z]+)(\?.*)?$/i, '$1$2') : src; }

  var PATHS = {
    Flame: '<path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/>',
    Filter: '<polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>',
    Snowflake: '<line x1="2" x2="22" y1="12" y2="12"/><line x1="12" x2="12" y1="2" y2="22"/><path d="m20 16-4-4 4-4"/><path d="m4 8 4 4-4 4"/><path d="m16 4-4 4-4-4"/><path d="m8 20 4-4 4 4"/>',
    Droplets: '<path d="M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z"/><path d="M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97"/>',
    Thermometer: '<path d="M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z"/>',
    Sparkles: '<path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/><path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/>',
    Smartphone: '<rect width="14" height="20" x="5" y="2" rx="2" ry="2"/><path d="M12 18h.01"/>',
    Check: '<path d="M20 6 9 17l-5-5"/>',
    ArrowRight: '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
    ArrowLeft: '<path d="m12 19-7-7 7-7"/><path d="M19 12H5"/>',
    X: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
    Plus: '<path d="M5 12h14"/><path d="M12 5v14"/>',
    SearchX: '<path d="m13.5 8.5-5 5"/><path d="m8.5 8.5 5 5"/><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>',
    Sliders: '<line x1="4" x2="4" y1="21" y2="14"/><line x1="4" x2="4" y1="10" y2="3"/><line x1="12" x2="12" y1="21" y2="12"/><line x1="12" x2="12" y1="8" y2="3"/><line x1="20" x2="20" y1="21" y2="16"/><line x1="20" x2="20" y1="12" y2="3"/><line x1="2" x2="6" y1="14" y2="14"/><line x1="10" x2="14" y1="8" y2="8"/><line x1="18" x2="22" y1="16" y2="16"/>',
    Package: '<path d="m7.5 4.27 9 5.15"/><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/>',
    Wrench: '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>',
    ShoppingBag: '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>',
    Box: '<path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/>',
    Move: '<path d="M12 2v20M2 12h20"/><path d="m15 5-3-3-3 3"/><path d="m15 19-3 3-3-3"/><path d="m5 9-3 3 3 3"/><path d="m19 9 3 3-3 3"/>',
    Lock: '<rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
  };
  function icon(name, size, color, sw) {
    size = size || 16; color = color || 'currentColor'; sw = sw || 1.6;
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="' + color + '" stroke-width="' + sw + '" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:middle">' + (PATHS[name] || '') + '</svg>';
  }

  /* ---------- katalog-logik (port fra data.jsx) ---------- */
  function systemsMatching(sel) {
    if (!sel.length) return U.systems;
    return U.systems.filter(function (s) {
      return sel.every(function (fn) { return s.functions.indexOf(fn) !== -1 || (s.optional || []).indexOf(fn) !== -1; });
    });
  }
  function faucetsForSystem(sys) {
    if (!sys) return U.faucets;
    if (sys.id === 'classic') return U.faucets.filter(function (f) { return f.type === 'mechanical'; });
    if (sys.id === 'infinityplus') return U.faucets.filter(function (f) { return f.series === 'Orbit' && f.flavor === true; });
    return U.faucets.filter(function (f) { return f.type === 'electronic' && f.flavor === false; });
  }
  function accessoriesForSystem(sys) {
    if (!sys) return U.accessories;
    return U.accessories.filter(function (a) { return a.fitsAny === 'all' || (Array.isArray(a.fitsAny) && a.fitsAny.indexOf(sys.id) !== -1); });
  }
  function bySysId(id) { return U.systems.filter(function (s) { return s.id === id; })[0]; }
  function byFaucetId(id) { return U.faucets.filter(function (f) { return f.id === id; })[0]; }

  /* ---------- kurv ---------- */
  function addToCart(variantIds, then) {
    var items = variantIds.filter(Boolean).map(function (id) { return { id: id, quantity: 1 }; });
    if (!items.length) { alert('Ingen produkter at lægge i kurven.'); return; }
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Kurv-fejl'); });
      if (typeof then === 'function') { then(); return; }
      window.location.href = then || '/checkout';
    }).catch(function (e) {
      alert('Der opstod en fejl ved checkout: ' + e.message);
    });
  }

  /* ---------- kurv-sidepanel (port af Cart.jsx) ---------- */
  function fetchCart() { return fetch('/cart.js').then(function (r) { return r.json(); }); }

  function updateCartBadge(count) {
    document.querySelectorAll('#unito-header a[aria-label="Kurv"]').forEach(function (a) {
      var badge = a.querySelector('[data-cart-badge]') || a.querySelector('span.absolute');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.setAttribute('data-cart-badge', '');
          badge.className = 'absolute -top-0.5 -right-0.5 bg-teal text-paper text-[10px] font-medium rounded-full w-4 h-4 grid place-items-center';
          a.appendChild(badge);
        }
        badge.textContent = count;
        badge.style.display = '';
      } else if (badge) {
        badge.style.display = 'none';
      }
    });
  }

  function cartPanelHTML(cart) {
    var items = cart.items || [];
    var head = '<div class="p-6 flex items-center justify-between border-b border-black/5">' +
      '<div><div class="h-eyebrow mb-1">Kurv</div>' +
      '<div class="font-display text-2xl">' + cart.item_count + ' ' + (cart.item_count === 1 ? 'vare' : 'varer') + '</div></div>' +
      '<button type="button" data-cart-close class="w-10 h-10 rounded-full hover:bg-black/[0.04] grid place-items-center">' + icon('X', 18) + '</button></div>';
    var body;
    if (!items.length) {
      body = '<div class="flex-1 overflow-y-auto p-6"><div class="text-center py-20">' +
        '<div class="w-14 h-14 rounded-full bg-paper-2 grid place-items-center mx-auto mb-4">' + icon('ShoppingBag', 20, '#BCBCBC') + '</div>' +
        '<div class="font-medium mb-1">Kurven er tom</div>' +
        '<div class="text-[13px] text-ink-3">Brug konfiguratoren for at finde din vandhane.</div></div></div>';
    } else {
      body = '<div class="flex-1 overflow-y-auto p-6 space-y-4">' + items.map(function (it) {
        var sub = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : (it.vendor || '');
        var qty = it.quantity > 1 ? '<span class="text-ink-3">' + it.quantity + ' × </span>' : '';
        return '<div class="card p-4 flex gap-4">' +
          '<div class="w-20 h-20 rounded-xl overflow-hidden bg-paper-2 flex-shrink-0">' +
          (it.image ? '<img src="' + esc(it.image) + '" alt="' + esc(it.product_title) + '" class="w-full h-full object-contain" loading="lazy">' : '') + '</div>' +
          '<div class="flex-1 min-w-0">' +
          '<div class="font-medium text-[14px]">' + qty + (it.url ? '<a href="' + esc(it.url) + '" class="hover:underline">' + esc(it.product_title) + '</a>' : esc(it.product_title)) + '</div>' +
          (sub ? '<div class="text-[12px] text-ink-3 mt-1">' + esc(sub) + '</div>' : '') +
          '<div class="flex items-center justify-between mt-3">' +
          '<div class="font-medium text-[14px]">' + fmt(it.final_line_price / 100) + '</div>' +
          '<button type="button" data-cart-remove="' + esc(it.key) + '" class="text-[11px] text-ink-3 underline underline-offset-2 hover:text-ink">Fjern</button>' +
          '</div></div></div>';
      }).join('') + '</div>';
    }
    var foot = '';
    if (items.length) {
      foot = '<div class="p-6 border-t border-black/5">' +
        '<div class="flex items-center justify-between mb-4"><span class="text-[13px] text-ink-2">Total inkl. moms</span>' +
        '<span class="font-display text-2xl">' + fmt(cart.total_price / 100) + '</span></div>' +
        '<a href="/checkout" class="btn btn-primary w-full">' + icon('Lock', 14) + ' Til kassen</a>' +
        '<div class="text-center text-[11px] text-ink-3 mt-3">Fri fragt · 30 dages returret</div></div>';
    }
    return head + body + foot;
  }

  var cartDrawer = null;
  function closeCartDrawer() {
    if (!cartDrawer) return;
    var ov = cartDrawer; cartDrawer = null;
    var bd = ov.querySelector('[data-cart-backdrop]');
    var panel = ov.querySelector('[data-cart-panel]');
    if (bd) bd.style.opacity = '0';
    if (panel) panel.style.transform = 'translateX(100%)';
    document.body.style.overflow = '';
    setTimeout(function () { ov.remove(); }, 330);
  }

  function renderCartDrawer(cart) {
    updateCartBadge(cart.item_count);
    if (cartDrawer) {
      var p = cartDrawer.querySelector('[data-cart-panel]');
      p.innerHTML = cartPanelHTML(cart);
      bindCartDrawer(cartDrawer);
      return;
    }
    var ov = document.createElement('div');
    ov.className = 'fixed inset-0 z-50';
    ov.innerHTML = '<div data-cart-backdrop class="absolute inset-0 bg-ink/40 backdrop-blur-sm" style="opacity:0;transition:opacity 250ms ease"></div>' +
      '<div data-cart-panel class="absolute top-0 right-0 h-full w-full sm:w-[440px] bg-paper shadow-2xl flex flex-col" style="transform:translateX(100%);transition:transform 320ms cubic-bezier(.32,.72,0,1)">' + cartPanelHTML(cart) + '</div>';
    document.body.appendChild(ov);
    document.body.style.overflow = 'hidden';
    cartDrawer = ov;
    ov.querySelector('[data-cart-backdrop]').addEventListener('click', closeCartDrawer);
    bindCartDrawer(ov);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        ov.querySelector('[data-cart-backdrop]').style.opacity = '1';
        ov.querySelector('[data-cart-panel]').style.transform = 'translateX(0)';
      });
    });
  }

  function bindCartDrawer(ov) {
    ov.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCartDrawer); });
    ov.querySelectorAll('[data-cart-remove]').forEach(function (b) {
      b.addEventListener('click', function () {
        b.textContent = '…';
        fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: b.getAttribute('data-cart-remove'), quantity: 0 }),
        }).then(function (r) { return r.json(); }).then(function (cart) {
          renderCartDrawer(cart);
        }).catch(function () { b.textContent = 'Fjern'; });
      });
    });
  }

  function openCartDrawer() {
    fetchCart().then(renderCartDrawer).catch(function () { window.location.href = '/cart'; });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('#unito-header a[aria-label="Kurv"]');
    if (a) { e.preventDefault(); openCartDrawer(); }
  });

  /* ---------- produktside (PDP): læg i kurv → sidepanel ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-pdp-form]');
    if (!f) return;
    e.preventDefault();
    var idEl = f.querySelector('[name="id"]');
    var qtyEl = f.querySelector('[name="quantity"]');
    var btn = f.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (!idEl) return;
    if (btn) { btn.disabled = true; btn.textContent = 'Lægger i kurv …'; }
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(idEl.value, 10), quantity: parseInt((qtyEl && qtyEl.value) || '1', 10) }] }),
    }).then(function (r) {
      if (!r.ok) throw new Error('kurv-fejl');
      if (btn) { btn.disabled = false; btn.innerHTML = label; }
      openCartDrawer();
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.innerHTML = label; }
      f.submit();
    });
  });

  /* ---------- modal-infrastruktur ---------- */
  function openModal(html, cls) {
    var ov = document.createElement('div');
    ov.className = 'fixed inset-0 z-50 grid place-items-center bg-ink/40 backdrop-blur-sm p-4';
    ov.innerHTML = '<div class="card ' + (cls || 'max-w-2xl') + ' w-full max-h-[92vh] overflow-auto relative" data-modal-inner>' + html + '</div>';
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    function close() { ov.remove(); document.body.style.overflow = ''; }
    ov.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.body.appendChild(ov);
    document.body.style.overflow = 'hidden';
    ov.closeModal = close;
    return ov;
  }
  function bindZoom(scope) {
    scope.querySelectorAll('[data-zoom]').forEach(function (box) {
      var inner = box.querySelector('[data-zoom-inner]');
      if (!inner) return;
      box.style.cursor = 'zoom-in'; box.style.overflow = 'hidden';
      inner.style.transition = 'transform 200ms ease-out';
      box.addEventListener('mousemove', function (e) {
        var r = box.getBoundingClientRect();
        inner.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      box.addEventListener('mouseenter', function () { inner.style.transform = 'scale(2.4)'; });
      box.addEventListener('mouseleave', function () { inner.style.transform = 'scale(1)'; });
    });
  }

  /* ---------- 3D-visning ---------- */
  function ensure3D(cb) {
    if (window.UnitoFaucet3D) return cb();
    if (!document.getElementById('unito-faucet3d-mod')) {
      var s = document.createElement('script');
      s.type = 'module'; s.id = 'unito-faucet3d-mod';
      s.src = window.__FAUCET3D_URL || (ASSETS + 'faucet3d.js');
      document.body.appendChild(s);
    }
    var tries = 0;
    (function poll() {
      if (window.UnitoFaucet3D) return cb();
      if (tries++ > 160) return cb(new Error('3D-modulet kunne ikke indlæses'));
      setTimeout(poll, 120);
    })();
  }
  function mount3D(el, f) {
    el.innerHTML = '<div class="absolute inset-0" style="background: radial-gradient(120% 100% at 50% 18%, #ffffff 0%, #eceae5 55%, #dcdad3 100%)"><div class="w-full h-full" data-3d-canvas></div><div class="absolute inset-0 grid place-items-center pointer-events-none" data-3d-status><div class="text-center"><div class="w-8 h-8 rounded-full border-2 border-black/10 border-t-teal animate-spin mx-auto"></div><div class="text-[11.5px] text-ink-3 mt-3">Indlæser 3D …</div></div></div></div>';
    var canvas = el.querySelector('[data-3d-canvas]');
    var status = el.querySelector('[data-3d-status]');
    ensure3D(function (err) {
      if (err || !window.UnitoFaucet3D) { status.innerHTML = '<div class="text-center px-6">' + icon('Box', 24, '#BCBCBC') + '<div class="text-[12.5px] text-ink-3 mt-2">3D-modellen kunne ikke indlæses.</div></div>'; return; }
      try {
        var ctrl = window.UnitoFaucet3D.mount(canvas, ASSETS + f.model3d, {
          color: COLOR_DOT[f.color], autoRotate: true,
          onLoad: function () { status.remove(); addCtrls(); },
          onError: function () { status.innerHTML = '<div class="text-center px-6">' + icon('Box', 24, '#BCBCBC') + '<div class="text-[12.5px] text-ink-3 mt-2">3D-modellen kunne ikke indlæses.</div></div>'; },
        });
        el.dispose3d = ctrl;
        function addCtrls() {
          var wrap = document.createElement('div');
          wrap.innerHTML =
            '<button data-water class="absolute top-3 right-3 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11.5px] font-medium bg-paper/90 text-ink-2">' + icon('Droplets', 12, '#303030') + ' Vand</button>' +
            '<div class="absolute bottom-3 right-3 flex flex-col gap-1.5">' +
            '<button data-zin class="w-9 h-9 rounded-full bg-paper/90 grid place-items-center text-[18px] font-medium">+</button>' +
            '<button data-zout class="w-9 h-9 rounded-full bg-paper/90 grid place-items-center text-[20px] font-medium">−</button></div>' +
            '<div class="absolute bottom-3 left-1/2 -translate-x-1/2 px-3 py-1.5 rounded-full bg-ink/70 text-paper text-[10.5px] tracking-wide pointer-events-none flex items-center gap-1.5">' + icon('Move', 11, '#fff') + ' Træk: rotér · scroll/+−: zoom</div>';
          while (wrap.firstChild) el.firstChild.appendChild(wrap.firstChild);
          var water = false;
          el.querySelector('[data-water]').addEventListener('click', function () {
            water = !water;
            this.className = 'absolute top-3 right-3 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11.5px] font-medium ' + (water ? 'bg-teal text-paper' : 'bg-paper/90 text-ink-2');
            this.innerHTML = icon('Droplets', 12, water ? '#fff' : '#303030') + ' Vand';
            if (ctrl && ctrl.setWater) ctrl.setWater(water);
          });
          el.querySelector('[data-zin]').addEventListener('click', function () { if (ctrl && ctrl.zoomBy) ctrl.zoomBy(0.7); });
          el.querySelector('[data-zout]').addEventListener('click', function () { if (ctrl && ctrl.zoomBy) ctrl.zoomBy(1.4); });
        }
      } catch (e) { console.error(e); }
    });
  }

  /* ---------- system-modal (Læs mere) ---------- */
  function specHTML(label, value) {
    return '<div><div class="text-[10px] uppercase tracking-wider text-ink-3 mb-1">' + esc(label) + '</div><div class="text-[12.5px] leading-snug">' + esc(value) + '</div></div>';
  }
  function openSystemModal(sys, onSelect) {
    var d = sys.details;
    var html =
      '<div class="aspect-[16/10] relative bg-paper-2"><img src="' + img(sys.image) + '" alt="' + esc(sys.name) + '" class="w-full h-full object-contain p-10">' +
      '<button data-close class="absolute top-4 right-4 w-9 h-9 rounded-full bg-paper grid place-items-center shadow-soft">' + icon('X', 16) + '</button></div>' +
      '<div class="p-8"><div class="font-display text-4xl mb-1">' + esc(sys.name) + '</div>' +
      '<div class="text-ink-3 mb-6 text-[14px]">' + esc(sys.tagline) + '</div>' +
      '<p class="text-[14.5px] leading-relaxed mb-6 text-ink-2">' + esc(sys.desc) + '</p>' +
      '<div class="grid sm:grid-cols-2 gap-x-6 gap-y-3 mb-6"><div><div class="h-eyebrow mb-2" style="color:#d8372d">Inkluderet</div><ul class="space-y-1.5">' +
      sys.functions.map(function (id) { var f = FN[id]; return '<li class="flex items-center gap-2.5 text-[13.5px]"><span class="w-2 h-2 rounded-full" style="background:' + f.color + '"></span>' + esc(f.name) + '</li>'; }).join('') +
      '</ul></div>' +
      ((sys.optional || []).length ? '<div><div class="h-eyebrow mb-2" style="color:#d8372d">Tilkøb</div><ul class="space-y-1.5">' +
        sys.optional.map(function (id) { var f = FN[id]; return '<li class="flex items-center gap-2.5 text-[13.5px] text-ink-2"><span class="w-2 h-2 rounded-full border-2" style="border-color:' + f.color + '"></span>' + esc(f.name) + '</li>'; }).join('') + '</ul></div>' : '') +
      '</div>';
    if (d) {
      html += '<div class="mb-7 pb-7 border-b border-black/5"><p class="font-display text-[19px] md:text-[21px] leading-snug mb-4">' + esc(d.headline) + '</p>' +
        d.intro.map(function (p) { return '<p class="text-[14px] leading-relaxed text-ink mb-3">' + esc(p) + '</p>'; }).join('') +
        '<div class="h-eyebrow mt-6 mb-3" style="color:#d8372d">Derfor vil du elske ' + esc(sys.name) + '</div><div class="space-y-3">' +
        d.benefits.map(function (b) {
          var s = '<div class="flex gap-3"><span class="mt-1.5 w-1.5 h-1.5 rounded-full bg-teal flex-shrink-0"></span><div>' +
            '<div class="text-[14px] font-medium">' + esc(b.title) + '</div>';
          if (b.body) s += '<div class="text-[13px] text-ink leading-relaxed mt-0.5" style="white-space:pre-line">' + esc(b.body) + '</div>';
          if (Array.isArray(b.points)) s += '<ul class="mt-1.5 space-y-1">' + b.points.map(function (p) { return '<li class="flex gap-2 text-[13px] text-ink-2"><span class="text-teal mt-0.5">·</span>' + esc(p) + '</li>'; }).join('') + '</ul>';
          if (Array.isArray(b.examples)) s += '<div class="mt-2 space-y-1">' + b.examples.map(function (p) { return '<div class="flex gap-1.5 text-[13px] text-ink"><span class="text-teal">→</span>' + esc(p) + '</div>'; }).join('') + '</div>';
          if (b.note) s += '<div class="text-[12px] text-ink leading-relaxed mt-2">' + esc(b.note) + '</div>';
          return s + '</div></div>';
        }).join('') + '</div>' +
        (d.compact ? '<div class="mt-5 rounded-2xl bg-paper-2 p-4 text-[13px] text-ink-2 leading-relaxed"><span class="font-medium text-ink">Elegant, kompakt — nemt fra start. </span>' + esc(d.compact) + '</div>' : '') +
        '<div class="h-eyebrow mt-6 mb-3" style="color:#d8372d">Teknisk specifikation</div>' +
        '<div class="grid grid-cols-3 gap-3 mb-4 pb-4 border-b border-black/5">' + specHTML('Mål', sys.dimensions) + specHTML('Tank', sys.tank) + specHTML('Gennemstrømning', sys.flow) + '</div>' +
        '<div class="grid sm:grid-cols-2 gap-x-6 gap-y-3">' + d.techSpecs.map(function (s) { return '<div><div class="text-[12px] font-medium">' + esc(s.label) + '</div><div class="text-[12.5px] text-ink-2 leading-snug mt-0.5">' + esc(s.value) + '</div></div>'; }).join('') + '</div></div>';
    } else {
      html += '<div class="h-eyebrow mt-6 mb-3" style="color:#d8372d">Teknisk specifikation</div><div class="grid grid-cols-3 gap-3 mb-6">' + specHTML('Mål', sys.dimensions) + specHTML('Tank', sys.tank) + specHTML('Gennemstrømning', sys.flow) + '</div>';
    }
    html += '<div class="flex items-center justify-between pt-6 border-t border-black/5"><div><div class="text-[10.5px] uppercase text-ink-3 tracking-wider">Fra</div><div class="font-display text-3xl">' + fmt(sys.price) + '</div></div>' +
      '<button data-select-sys class="btn btn-primary">Vælg ' + esc(sys.name) + '</button></div>' +
      (sys.url ? '<div class="pt-3 text-right"><a href="' + esc(sys.url) + '" class="text-[12.5px] underline underline-offset-4 text-ink-2 hover:text-ink">Se produktside →</a></div>' : '') + '</div>';
    var ov = openModal(html, 'max-w-2xl');
    ov.querySelector('[data-select-sys]').addEventListener('click', function () {
      ov.closeModal();
      if (onSelect) onSelect(sys); else preselectAndGo({ system: sys.id });
    });
  }

  /* ---------- vandhane-modal (Læs mere) ---------- */
  function openFaucetModal(f, onConfigure) {
    var info = U.seriesInfo[f.series] || {};
    var compatible = f.type === 'mechanical' ? ['Classic'] : f.flavor ? ['Infinity+'] : ['Lava', 'Sparkle', 'Elements', 'Infinity'];
    var allImages = [f.image].concat(f.gallery || []);
    var d = f.details;
    var html =
      '<button data-close class="absolute top-4 right-4 z-20 w-9 h-9 rounded-full bg-paper grid place-items-center shadow-soft">' + icon('X', 16) + '</button>' +
      '<div class="grid md:grid-cols-2 border-b border-black/5">' +
      '<div class="bg-paper-2 relative aspect-square md:aspect-auto md:min-h-[360px] flex flex-col">' +
      '<div class="relative flex-1" data-media>' +
      '<div class="w-full h-full absolute inset-0" data-photo data-zoom><div class="w-full h-full" data-zoom-inner><img src="' + img(hiRes(allImages[0])) + '" alt="' + esc(f.model) + '" class="w-full h-full object-contain p-8" data-main-img></div></div>' +
      (f.model3d ? '<div class="absolute top-4 left-4 z-10 inline-flex rounded-full bg-paper/90 shadow-soft p-1">' +
        '<button data-mode="photo" class="px-3 py-1.5 rounded-full text-[11.5px] font-medium bg-ink text-paper inline-flex items-center gap-1.5">' + icon('Box', 12, '#fff') + ' Foto</button>' +
        '<button data-mode="3d" class="px-3 py-1.5 rounded-full text-[11.5px] font-medium text-ink-2 inline-flex items-center gap-1.5">' + icon('Move', 12, '#303030') + ' 3D</button></div>' : '') +
      (f.flavor ? '<div class="absolute bottom-4 left-4 px-2.5 py-1 rounded-full bg-flav text-paper text-[10.5px] tracking-wide">Flavor</div>' : '') +
      '</div>' +
      (allImages.length > 1 ? '<div class="flex gap-2 p-3 overflow-x-auto bg-paper/60" data-thumbs>' + allImages.map(function (src, i) {
        return '<button data-thumb="' + i + '" class="flex-shrink-0 w-14 h-14 rounded-xl overflow-hidden bg-paper-2 ring-2 ' + (i === 0 ? 'ring-teal' : 'ring-transparent') + '"><img src="' + img(src) + '" class="w-full h-full object-contain p-1.5"></button>';
      }).join('') + '</div>' : '') +
      '</div>' +
      '<div class="p-7 md:p-9 flex flex-col">' +
      '<div class="h-eyebrow !text-ink-3 mb-2">' + esc(f.series) + '-serien</div>' +
      '<div class="font-display text-[32px] md:text-[36px] leading-tight mb-1">' + esc(f.model) + '</div>' +
      '<div class="text-[13.5px] text-ink-3 mb-4">' + esc(f.color) + ' · ' + esc(SPOUT_LABEL[f.spout]) + '</div>' +
      ((d && d.tagline) || info.headline ? '<div class="font-display text-[18px] text-teal mb-2 leading-snug">' + esc((d && d.tagline) || info.headline) + '</div>' : '') +
      ((d && d.intro) || info.body ? '<p class="text-[13.5px] text-ink-2 leading-relaxed mb-5">' + esc((d && d.intro) || info.body) + '</p>' : '') +
      '<div class="grid grid-cols-2 gap-x-5 gap-y-3 mb-5">' +
      '<div><div class="text-[10px] uppercase tracking-wider text-ink-3 mb-1">Farve</div><div class="text-[13px] leading-snug"><span class="inline-flex items-center gap-2"><span class="w-3 h-3 rounded-full ring-1 ring-black/10" style="background:' + (COLOR_DOT[f.color] || '#999') + '"></span>' + esc(f.color) + '</span></div></div>' +
      specHTML('Form', SPOUT_LABEL[f.spout]) +
      (f.size ? specHTML('Mål', f.size) : '') +
      (info.finish ? specHTML('Finish', info.finish) : '') +
      specHTML('Type', f.type === 'mechanical' ? 'Mekanisk' : 'Elektronisk') +
      specHTML('Vare-id', f.productId || '—') +
      '</div>' +
      '<div class="mb-5"><div class="h-eyebrow !text-ink-3 mb-2">Kompatibel med</div><div class="flex flex-wrap gap-1.5">' + compatible.map(function (c) { return '<span class="px-2.5 py-1 rounded-full bg-paper-2 text-[12px] text-ink-2">' + c + '</span>'; }).join('') + '</div></div>' +
      '<div class="mt-auto pt-4 border-t border-black/5 flex flex-wrap items-baseline justify-between gap-3">' +
      '<div><div class="text-[10.5px] uppercase text-ink-3 tracking-wider">Pris</div><div class="font-display text-2xl">' + fmt(f.price) + '</div></div>' +
      '<button data-configure class="btn btn-primary !py-2.5 text-[13px]">Byg med ' + esc(f.model) + ' ' + icon('ArrowRight', 12, '#fff') + '</button></div>' +
      '<div class="flex flex-wrap gap-2 pt-3">' +
      (f.url ? '<a href="' + esc(f.url) + '" class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-paper-2 text-[11.5px] text-ink-2">' + icon('ArrowRight', 11) + ' Se produktside</a>' : '') +
      '<a href="mailto:info@unitosmart.com?subject=' + encodeURIComponent('Bestil datablad — ' + f.model) + '" class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-paper-2 text-[11.5px] text-ink-2">' + icon('Box', 11) + ' Bestil datablad</a>' +
      '<a href="mailto:info@unitosmart.com?subject=' + encodeURIComponent('Bestil monteringsvejledning — ' + f.model) + '" class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-paper-2 text-[11.5px] text-ink-2">' + icon('Wrench', 11) + ' Monteringsvejledning</a>' +
      '</div></div></div>' +
      '<div class="p-7 md:p-9">' +
      (d && Array.isArray(d.bullets) && d.bullets.length ? '<div class="grid sm:grid-cols-2 gap-x-6 gap-y-3 mb-7">' + d.bullets.map(function (b) {
        return '<div class="flex gap-3"><div class="mt-1 flex-shrink-0">' + icon('Check', 13, '#D8372D', 2.5) + '</div><div><div class="text-[13.5px] font-medium leading-snug">' + esc(b.title) + '</div><div class="text-[12.5px] text-ink-2 leading-relaxed mt-0.5">' + esc(b.body) + '</div></div></div>';
      }).join('') + '</div>' : '') +
      (d && Array.isArray(d.examples) && d.examples.length ? '<div class="pt-6 border-t border-black/5">' +
        (d.examplesIntro ? '<p class="text-[12.5px] text-ink-3 leading-relaxed mb-4 max-w-2xl">' + esc(d.examplesIntro) + '</p>' : '') +
        '<div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">' + d.examples.map(function (ex) {
          var s = '<div class="rounded-2xl bg-paper-2 p-4"><div class="text-[13.5px] font-medium mb-1.5">' + esc(ex.title) + '</div>';
          if (ex.lead) s += '<div class="text-[12px] text-ink-2 mb-2 leading-relaxed">' + esc(ex.lead) + '</div>';
          if (Array.isArray(ex.points)) s += '<ul class="space-y-1 mb-3">' + ex.points.map(function (p) { return '<li class="flex gap-2 text-[12px] text-ink-2"><span class="text-teal mt-0.5">·</span>' + esc(p) + '</li>'; }).join('') + '</ul>';
          if (Array.isArray(ex.examples)) s += '<div class="space-y-1 mb-3">' + ex.examples.map(function (p) { return '<div class="flex gap-1.5 text-[12px] text-ink">' + icon('ArrowRight', 11, '#D8372D') + ' ' + esc(p) + '</div>'; }).join('') + '</div>';
          if (ex.note) s += '<div class="text-[11px] text-ink-3 leading-relaxed italic">' + esc(ex.note) + '</div>';
          return s + '</div>';
        }).join('') + '</div></div>' : '') +
      '</div>';
    var ov = openModal(html, 'max-w-4xl');
    bindZoom(ov);
    var media = ov.querySelector('[data-media]');
    var photo = ov.querySelector('[data-photo]');
    var mainImg = ov.querySelector('[data-main-img]');
    ov.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        mainImg.src = img(hiRes(allImages[parseInt(t.getAttribute('data-thumb'), 10)]));
        ov.querySelectorAll('[data-thumb]').forEach(function (tt) { tt.className = tt.className.replace('ring-teal', 'ring-transparent'); });
        t.className = t.className.replace('ring-transparent', 'ring-teal');
      });
    });
    if (f.model3d) {
      var threeD = null;
      ov.querySelectorAll('[data-mode]').forEach(function (b) {
        b.addEventListener('click', function () {
          var mode = b.getAttribute('data-mode');
          ov.querySelectorAll('[data-mode]').forEach(function (bb) {
            var on = bb === b;
            bb.className = 'px-3 py-1.5 rounded-full text-[11.5px] font-medium inline-flex items-center gap-1.5 ' + (on ? 'bg-ink text-paper' : 'text-ink-2');
            bb.innerHTML = icon(bb.getAttribute('data-mode') === '3d' ? 'Move' : 'Box', 12, on ? '#fff' : '#303030') + (bb.getAttribute('data-mode') === '3d' ? ' 3D' : ' Foto');
          });
          if (mode === '3d') {
            photo.style.display = 'none';
            if (!threeD) {
              threeD = document.createElement('div');
              threeD.className = 'absolute inset-0';
              media.appendChild(threeD);
              mount3D(threeD, f);
            } else threeD.style.display = '';
          } else {
            photo.style.display = '';
            if (threeD) threeD.style.display = 'none';
          }
        });
      });
    }
    ov.querySelector('[data-configure]').addEventListener('click', function () {
      ov.closeModal();
      if (onConfigure) onConfigure(f); else preselectAndGo({ faucet: f.id });
    });
  }

  /* ---------- tilbehørs-modal ---------- */
  function openAccessoryModal(a) {
    var extras = U.accExtras[a.id] || {};
    var fits = a.fitsAny === 'all' ? null : (a.fitsAny || []).map(function (id) { return (bySysId(id) || { name: id }).name; });
    var html =
      '<div class="grid md:grid-cols-2">' +
      '<div class="bg-paper-2 relative aspect-square md:aspect-auto md:min-h-[380px] p-8 grid place-items-center"><img src="' + img(a.image) + '" alt="' + esc(a.name) + '" class="max-h-72 w-full object-contain"></div>' +
      '<div class="p-7 md:p-9 relative">' +
      '<button data-close class="absolute top-4 right-4 w-9 h-9 rounded-full bg-paper-2 grid place-items-center">' + icon('X', 16) + '</button>' +
      '<div class="h-eyebrow !text-ink-3 mb-2">Tilbehør</div>' +
      '<div class="font-display text-[26px] md:text-[30px] leading-tight mb-2">' + esc(a.name) + '</div>' +
      '<p class="text-[14px] text-ink-2 leading-relaxed mb-5">' + esc(a.desc) + '</p>' +
      (extras.what ? '<div class="mb-5"><div class="h-eyebrow !text-ink-3 mb-2">I kassen</div><p class="text-[13.5px] text-ink-2 leading-relaxed">' + esc(extras.what) + '</p></div>' : '') +
      (extras.use ? '<div class="mb-5"><div class="h-eyebrow !text-ink-3 mb-2">Sådan bruges det</div><p class="text-[13.5px] text-ink-2 leading-relaxed">' + esc(extras.use) + '</p></div>' : '') +
      '<div class="mb-5 pt-4 border-t border-black/5"><div class="h-eyebrow !text-ink-3 mb-2">Passer til</div>' +
      (fits ? '<div class="flex flex-wrap gap-1.5">' + fits.map(function (n) { return '<span class="px-2.5 py-1 rounded-full bg-paper-2 text-[12px] text-ink-2">' + esc(n) + '</span>'; }).join('') + '</div>' : '<div class="text-[13px] text-ink-2">Alle UNITO-modeller</div>') + '</div>' +
      (a.url ? '<div class="text-right mb-2"><a href="' + esc(a.url) + '" class="text-[12px] underline underline-offset-4 text-ink-2 hover:text-ink">Se produktside →</a></div>' : '') +
      '<div class="pt-4 border-t border-black/5 flex items-baseline justify-between gap-3 mb-4">' +
      '<div><div class="text-[10.5px] uppercase text-ink-3 tracking-wider">Pris</div><div class="font-display text-2xl">' + fmt(a.price) + '</div></div>' +
      '<button data-add class="btn btn-primary !py-2.5 text-[13px]">Læg i kurv ' + icon('ShoppingBag', 12, '#fff') + '</button></div>' +
      '</div></div>';
    var ov = openModal(html, 'max-w-3xl');
    ov.querySelector('[data-add]').addEventListener('click', function () {
      addToCart([a.variantId], function () { ov.closeModal(); openCartDrawer(); });
    });
  }

  /* ---------- advarsels-modal ---------- */
  function openWarning(data) {
    var html = '<div class="p-7"><div class="w-12 h-12 rounded-full bg-flav/10 grid place-items-center mb-4">' + icon('Sparkles', 20, '#9B5BA8') + '</div>' +
      '<div class="font-display text-2xl mb-2">' + esc(data.title) + '</div>' +
      '<p class="text-[14px] text-ink-2 leading-relaxed">' + esc(data.body) + '</p></div>' +
      '<div class="px-7 pb-7 flex gap-2">' + data.actions.map(function (a, i) {
        return '<button data-act="' + i + '" class="flex-1 btn ' + (i === 0 ? 'btn-primary' : 'btn-ghost') + ' !py-2.5 text-[13px]">' + esc(a.label) + '</button>';
      }).join('') + '</div>';
    var ov = openModal(html, 'max-w-md');
    ov.querySelectorAll('[data-act]').forEach(function (b) {
      b.addEventListener('click', function () {
        var a = data.actions[parseInt(b.getAttribute('data-act'), 10)];
        ov.closeModal();
        if (a.onClick) a.onClick();
      });
    });
  }

  /* ---------- sammenlignings-modal ---------- */
  function openCompareModal(ids, ctx) {
    var items = ids.map(byFaucetId).filter(Boolean);
    if (!items.length) return;
    var rows = [
      ['Modelnr.', function (f) { return esc(f.model); }],
      ['Serie', function (f) { return esc(f.series); }],
      ['Farve', function (f) { return '<span class="inline-flex items-center gap-2"><span class="w-3 h-3 rounded-full ring-1 ring-black/10" style="background:' + (COLOR_DOT[f.color] || '#999') + '"></span>' + esc(f.color) + '</span>'; }],
      ['Form', function (f) { return esc(SPOUT_LABEL[f.spout]); }],
      ['Funktion', function (f) { return [f.pullout && 'Udtræk', f.flavor && 'Flavor'].filter(Boolean).join(' · ') || '–'; }],
      ['Lys', function (f) { return f.light ? icon('Check', 14, '#D8372D', 2.5) : '<span class="text-ink-3">–</span>'; }],
      ['Tekst-display', function (f) { return f.display ? icon('Check', 14, '#D8372D', 2.5) : '<span class="text-ink-3">–</span>'; }],
      ['Størrelse', function (f) { return esc(f.size || '—'); }],
      ['Pris', function (f) { return '<span class="font-medium">' + fmt(f.price) + '</span>'; }],
    ];
    var html = '<div class="sticky top-0 z-10 bg-paper/95 p-5 border-b border-black/5 flex items-center justify-between">' +
      '<div><div class="h-eyebrow !text-ink-3 mb-1">Sammenligning · ' + items.length + ' vandhane' + (items.length !== 1 ? 'r' : '') + '</div><div class="font-display text-2xl">Hvilken passer bedst?</div></div>' +
      '<button data-close class="w-9 h-9 rounded-full bg-paper-2 grid place-items-center">' + icon('X', 16) + '</button></div>' +
      '<div class="p-5 md:p-8"><div class="grid gap-4" style="grid-template-columns: 120px repeat(' + items.length + ', minmax(0, 1fr))"><div></div>' +
      items.map(function (f) {
        return '<div class="text-center"><div class="aspect-[3/4] bg-paper-2 rounded-2xl overflow-hidden relative mb-3"><img src="' + img(f.image) + '" class="w-full h-full object-contain p-4"></div>' +
          '<div class="font-display text-xl">' + esc(f.model) + '</div>' +
          '<button data-pick="' + f.id + '" class="mt-3 inline-flex items-center gap-2 px-4 py-2 rounded-full text-[12px] bg-ink text-paper">Vælg denne</button></div>';
      }).join('') +
      rows.map(function (r) {
        return '<div class="text-[11px] uppercase tracking-wider text-ink-3 py-3.5 border-t border-black/5">' + r[0] + '</div>' +
          items.map(function (f) { return '<div class="text-[13px] py-3.5 border-t border-black/5 text-ink">' + r[1](f) + '</div>'; }).join('');
      }).join('') +
      '</div></div>';
    var ov = openModal(html, 'max-w-5xl');
    ov.querySelectorAll('[data-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        ov.closeModal();
        if (ctx && ctx.onSelect) ctx.onSelect(byFaucetId(b.getAttribute('data-pick')));
      });
    });
  }

  /* ---------- preselect (katalogsider → konfigurator) ---------- */
  function preselectAndGo(sel) {
    try { sessionStorage.setItem('unito-preselect', JSON.stringify(sel)); } catch (e) {}
    window.location.href = '/#configurator';
  }

  /* ================= KONFIGURATOR ================= */
  var root = document.querySelector('#configurator [data-konfig-body]');
  if (root) initConfigurator();

  function initConfigurator() {
    var stepsEl = document.querySelector('#configurator [data-konfig-steps]');
    var barEl = document.querySelector('#configurator [data-konfig-bar]');
    var st = { step: 1, filters: [], system: null, faucet: null, acc: [], compare: [], f2: { series: 'Alle', spout: 'Alle', color: 'Alle' } };
    var STEP1_FILTERS = ['kogende', 'isvand', 'brusvand', 'filtreret', 'mixvand', 'flavor'];
    var STEPS = [{ id: 1, label: 'Vandsystem', short: 'System' }, { id: 2, label: 'Vandhane', short: 'Hane' }, { id: 3, label: 'Tilbehør', short: 'Tilbehør' }];

    // Preselect fra katalogsider
    try {
      var pre = JSON.parse(sessionStorage.getItem('unito-preselect') || 'null');
      sessionStorage.removeItem('unito-preselect');
      if (pre) {
        if (pre.system) { st.system = bySysId(pre.system); st.step = 2; }
        if (pre.faucet) {
          var pf = byFaucetId(pre.faucet);
          if (pf) {
            var sysid = pf.type === 'mechanical' ? 'classic' : pf.flavor ? 'infinityplus' : 'lava';
            st.system = bySysId(sysid); st.faucet = pf; st.step = 2;
          }
        }
        setTimeout(function () { var el = document.getElementById('configurator'); if (el) window.scrollTo({ top: el.offsetTop - 60 }); }, 100);
      }
    } catch (e) {}

    function scrollTop() { var el = document.getElementById('configurator'); if (el) window.scrollTo({ top: el.offsetTop - 60, behavior: 'smooth' }); }
    function total() {
      var accSum = U.accessories.filter(function (a) { return st.acc.indexOf(a.id) !== -1; }).reduce(function (s, a) { return s + a.price; }, 0);
      return (st.system ? st.system.price : 0) + (st.faucet ? st.faucet.price : 0) + accSum;
    }

    function stepsHTML() {
      return '<div class="flex items-center gap-3 md:gap-4">' + STEPS.map(function (s, i) {
        var done = st.step > s.id, active = st.step === s.id;
        return '<div class="flex items-center gap-2.5 min-w-0">' +
          '<div class="w-7 h-7 rounded-full grid place-items-center text-[12px] font-medium ' + (active ? 'bg-teal text-paper' : done ? 'bg-teal/15 text-teal' : 'bg-black/[0.06] text-ink-3') + '">' + (done ? icon('Check', 13, '#D8372D', 2.5) : s.id) + '</div>' +
          '<div class="text-[13px] hidden sm:block ' + (active ? 'text-ink font-medium' : done ? 'text-ink-2' : 'text-ink-3') + '">' + s.label + '</div>' +
          '<div class="text-[12px] sm:hidden ' + (active ? 'text-ink font-medium' : 'text-ink-3') + '">' + s.short + '</div></div>' +
          (i < 2 ? '<div class="flex-1 h-px bg-black/10 min-w-[24px]"></div>' : '');
      }).join('') + '</div>';
    }

    function sysCardHTML(sys) {
      var selected = st.system && st.system.id === sys.id;
      var optActive = st.filters.filter(function (fn) { return (sys.optional || []).indexOf(fn) !== -1; });
      return '<div class="card overflow-hidden hover-lift flex flex-col ' + (selected ? 'is-selected' : '') + '">' +
        '<div class="aspect-[5/4] relative overflow-hidden bg-paper-2"><img src="' + img(sys.image) + '" class="w-full h-full object-contain p-6">' +
        (!sys.smart ? '<div class="absolute top-4 left-4 px-2.5 py-1 rounded-full bg-paper/95 text-[10.5px] tracking-wide font-medium">Mekanisk</div>' : '') +
        (sys.id === 'infinityplus' ? '<div class="absolute top-4 left-4 px-2.5 py-1 rounded-full bg-flav/95 text-paper text-[10.5px] tracking-wide font-medium">Topmodel</div>' : '') +
        '<button data-details="' + sys.id + '" class="absolute top-3.5 right-3.5 inline-flex items-center gap-1.5 pl-3 pr-2.5 py-1.5 rounded-full bg-paper/95 text-[12px] font-medium">Læs mere ' + icon('ArrowRight', 12) + '</button></div>' +
        '<div class="p-6 flex-1 flex flex-col"><div class="flex items-baseline justify-between mb-1"><div class="font-display text-[26px] leading-tight">' + esc(sys.name) + '</div><div class="text-[13px] text-ink-2 font-medium whitespace-nowrap">Fra ' + fmt(sys.price) + '</div></div>' +
        '<div class="text-[12.5px] text-ink-3 mb-4 leading-snug">' + esc(sys.tagline) + '</div>' +
        '<div class="flex flex-wrap gap-1.5 mb-5">' +
        sys.functions.filter(function (id) { return id !== 'app'; }).map(function (id) { var f = FN[id]; return '<span class="tag" style="background:' + f.tint + ';color:#1f1f1f"><span class="dot" style="background:' + f.color + '"></span>' + esc(f.name) + '</span>'; }).join('') +
        (sys.optional || []).map(function (id) { var f = FN[id]; var hi = optActive.indexOf(id) !== -1; return '<span class="tag !border" style="background:transparent;border-style:' + (hi ? 'solid' : 'dashed') + ';border-color:' + (hi ? 'var(--tweak-accent)' : 'rgba(0,0,0,0.18)') + '"><span class="dot" style="background:' + f.color + ';opacity:0.7"></span>' + esc(f.name) + ' <span class="text-[10px] ' + (hi ? 'text-teal' : 'text-ink-3') + ' ml-0.5">· tilkøb</span></span>'; }).join('') +
        (sys.functions.indexOf('app') !== -1 ? '<span class="tag" style="background:rgba(20,20,20,0.05)">' + icon('Smartphone', 10) + ' App</span>' : '') +
        '</div><div class="mt-auto flex gap-2"><button data-pick-sys="' + sys.id + '" class="btn btn-primary flex-1 !py-2.5 !px-4 text-[13px]">Vælg ' + esc(sys.name) + '</button></div></div></div>';
    }

    function step1HTML() {
      var matched = systemsMatching(st.filters);
      return '<div class="rise"><div class="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-8"><div class="max-w-xl">' +
        '<div class="h-eyebrow mb-3" style="color:rgb(7,7,7);font-size:20px">Trin 1 af 3 — vandsystem</div>' +
        '<h3 class="h-display text-[34px] md:text-[52px]">Vælg dit vandsystem</h3>' +
        '<p class="text-ink-2 mt-3 text-[15px] leading-relaxed">Filtrér på de funktioner du ønsker — vi viser kun systemer der har dem alle. Stiplede tags betyder funktionen er tilgængelig som tilkøb.</p></div>' +
        '<div class="inline-flex items-center gap-3 px-4 py-2.5 rounded-full bg-paper-2 text-[12.5px] text-ink-2 self-start md:self-end"><span class="w-2 h-2 rounded-full bg-teal dot-pulse"></span><span><span class="font-medium text-ink">' + matched.length + '</span> af ' + U.systems.length + ' systemer matcher</span></div></div>' +
        '<div class="card p-3 md:p-4 mb-6"><div class="flex flex-wrap items-center gap-1.5">' +
        STEP1_FILTERS.map(function (id) {
          var f = FN[id], on = st.filters.indexOf(id) !== -1;
          return '<button data-filter="' + id + '" class="inline-flex items-center gap-2 pl-2 pr-3.5 py-1.5 rounded-full text-[12.5px] border ' + (on ? 'bg-ink text-paper border-ink' : 'bg-white text-ink-2 border-black/10') + '">' +
            '<span class="w-5 h-5 rounded-full grid place-items-center" style="background:' + (on ? 'rgba(255,255,255,0.16)' : f.tint) + '">' + icon(f.icon, 11, on ? '#fff' : f.color, 1.8) + '</span>' + esc(f.name) + (on ? ' ' + icon('X', 11, '#fff', 2) : '') + '</button>';
        }).join('') +
        (st.filters.length ? '<button data-reset-filters class="ml-1 text-[12px] text-ink-3 underline underline-offset-4">Nulstil filtre</button>' : '') +
        '</div></div>' +
        (matched.length === 0 ?
          '<div class="card p-12 text-center"><div class="w-12 h-12 rounded-full bg-paper-2 grid place-items-center mx-auto mb-4">' + icon('SearchX', 20, '#BCBCBC') + '</div><div class="font-medium text-[16px]">Ingen systemer matcher alle valg.</div><div class="text-[13px] text-ink-3 mt-1">Prøv at fjerne en funktion — fx kan kun Infinity+ håndtere saftevand.</div></div>' :
          '<div class="grid md:grid-cols-2 lg:grid-cols-3 gap-3">' + matched.map(sysCardHTML).join('') + '</div>') +
        '</div>';
    }

    function faucetCardHTML(f) {
      var selected = st.faucet && st.faucet.id === f.id;
      var inCmp = st.compare.indexOf(f.id) !== -1;
      return '<div class="card overflow-hidden flex flex-col hover-lift ' + (selected ? 'is-selected' : '') + '">' +
        '<div data-pick-faucet="' + f.id + '" class="block text-left cursor-pointer"><div class="aspect-[3/4] relative overflow-hidden bg-paper-2"><img src="' + img(f.image) + '" class="w-full h-full object-contain p-4">' +
        (f.flavor ? '<div class="absolute top-3 left-3 px-2 py-0.5 rounded-full bg-flav text-paper text-[10px] tracking-wide">Flavor</div>' : '') +
        (f.display ? '<div class="absolute top-3 right-3 px-2 py-0.5 rounded-full bg-ink text-paper text-[10px] tracking-wide">Display</div>' : '') +
        '<button data-faucet-details="' + f.id + '" class="absolute bottom-3 right-3 inline-flex items-center gap-1.5 pl-3 pr-2.5 py-1.5 rounded-full bg-paper/95 text-[11.5px] font-medium shadow-soft">Læs mere ' + icon('ArrowRight', 11) + '</button>' +
        '</div></div>' +
        '<div class="p-4 flex-1 flex flex-col"><div class="flex items-start justify-between gap-2 mb-1"><div><div class="font-medium text-[14px] leading-tight">' + esc(f.model) + '</div><div class="text-[11px] text-ink-3 mt-0.5">' + esc(f.series) + ' · ' + esc(SPOUT_LABEL[f.spout]) + '</div></div><div class="text-right"><div class="text-[13px] font-medium">' + fmt(f.price) + '</div></div></div>' +
        '<div class="flex items-center gap-2 mt-2"><span class="w-3 h-3 rounded-full ring-1 ring-black/10" style="background:' + (COLOR_DOT[f.color] || '#999') + '"></span><span class="text-[11px] text-ink-3">' + esc(f.color) + '</span>' + (f.pullout ? '<span class="ml-auto text-[10px] uppercase tracking-wider text-ink-3">Udtræk</span>' : '') + '</div>' +
        '<div class="mt-4 flex gap-2"><button data-pick-faucet="' + f.id + '" class="flex-1 text-[12px] py-2 rounded-full ' + (selected ? 'bg-teal text-paper' : 'bg-ink text-paper') + '">' + (selected ? 'Valgt' : 'Vælg') + '</button>' +
        '<button data-cmp="' + f.id + '" class="text-[12px] py-2 px-3 rounded-full border ' + (inCmp ? 'bg-teal/10 text-teal border-teal/20' : 'border-black/10 text-ink-2') + '"><span class="inline-flex items-center gap-1.5">' + icon('Sliders', 11) + ' ' + (inCmp ? 'I sammenligning' : 'Sammenlign') + '</span></button></div></div></div>';
    }

    function filterRowHTML(label, key, options, mapLabel, swatch) {
      return '<div class="flex items-center gap-2 flex-wrap"><div class="text-[10.5px] uppercase tracking-[0.16em] text-ink-3 mr-1.5">' + label + '</div><div class="flex flex-wrap gap-1">' +
        options.map(function (o) {
          var on = st.f2[key] === o;
          return '<button data-f2="' + key + ':' + o + '" class="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-[11.5px] ' + (on ? 'bg-ink text-paper' : 'bg-black/[0.04] text-ink-2') + '">' +
            (swatch && o !== 'Alle' ? '<span class="w-2.5 h-2.5 rounded-full ring-1 ring-black/10" style="background:' + (COLOR_DOT[o] || '#999') + '"></span>' : '') + ((mapLabel && mapLabel[o]) || o) + '</button>';
        }).join('') + '</div></div>';
    }

    function step2HTML() {
      var faucets = faucetsForSystem(st.system);
      var uniq = function (arr) { return arr.filter(function (v, i) { return arr.indexOf(v) === i; }); };
      var filtered = faucets.filter(function (f) {
        return (st.f2.series === 'Alle' || f.series === st.f2.series) && (st.f2.spout === 'Alle' || f.spout === st.f2.spout) && (st.f2.color === 'Alle' || f.color === st.f2.color);
      });
      var note = st.system.id === 'classic' ? 'Mekaniske vandhaner — passer kun til Classic.' :
        st.system.id === 'infinityplus' ? 'Infinity+ kører kun med Orbit-haner med Flavor-funktion.' :
        'Vælg en af de nedenstående Smart vandhaner som passer til dit Smart vandsystem.';
      return '<div class="rise"><div class="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-8"><div class="max-w-xl">' +
        '<div class="h-eyebrow mb-3" style="font-size:20px"><span style="color:#d8273d">Trin 2 af 3 — vandhane</span></div>' +
        '<h3 class="h-display text-[34px] md:text-[52px]"><span style="color:#070707">Vælg din vandhane</span></h3>' +
        '<p class="text-ink-2 mt-3 text-[15px] leading-relaxed">' + note + '</p></div>' +
        (st.compare.length ? '<button data-open-cmp class="self-start md:self-end inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-ink text-paper text-[13px]">' + icon('Sliders', 13, '#fff') + ' Sammenlign ' + st.compare.length + ' hane' + (st.compare.length !== 1 ? 'r' : '') + '</button>' : '') +
        '</div>' +
        '<div class="card p-4 mb-6 flex flex-col md:flex-row gap-4 md:items-center md:gap-6">' +
        filterRowHTML('Serie', 'series', ['Alle'].concat(uniq(faucets.map(function (f) { return f.series; })))) +
        filterRowHTML('Tud', 'spout', ['Alle'].concat(uniq(faucets.map(function (f) { return f.spout; }))), SPOUT_LABEL) +
        filterRowHTML('Farve', 'color', ['Alle'].concat(uniq(faucets.map(function (f) { return f.color; }))), null, true) +
        '</div>' +
        '<div class="flex items-center justify-between mb-3 text-[12px] text-ink-3"><span>' + filtered.length + ' af ' + faucets.length + ' vandhane' + (faucets.length !== 1 ? 'r' : '') + '</span>' +
        (st.compare.length ? '<button data-clear-cmp class="underline underline-offset-4">Ryd sammenligning</button>' : '') + '</div>' +
        (filtered.length === 0 ? '<div class="card p-12 text-center"><div class="text-[14px] text-ink-2">Ingen vandhaner matcher dine filtre.</div></div>' :
          '<div class="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">' + filtered.map(faucetCardHTML).join('') + '</div>') +
        '</div>';
    }

    function step3HTML() {
      var visible = accessoriesForSystem(st.system);
      return '<div class="rise"><div class="mb-8 max-w-xl"><div class="h-eyebrow mb-3">Trin 3 af 3 — tilbehør</div>' +
        '<h3 class="h-display text-[34px] md:text-[52px]">Tilbehør</h3>' +
        '<p class="text-ink-2 mt-3 text-[15px] leading-relaxed">Valgfrit. Du kan altid tilføje senere. Vi viser kun tilbehør der passer til <span class="font-medium text-ink">' + esc(st.system.name) + '</span>.</p></div>' +
        '<div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">' + visible.map(function (a) {
          var on = st.acc.indexOf(a.id) !== -1;
          return '<button data-acc="' + a.id + '" class="card overflow-hidden text-left hover-lift ' + (on ? 'is-selected' : '') + '">' +
            '<div class="aspect-[5/4] bg-paper-2 overflow-hidden relative"><img src="' + img(a.image) + '" class="w-full h-full object-contain p-6">' +
            '<div class="absolute top-3 right-3 w-7 h-7 rounded-full grid place-items-center ' + (on ? 'bg-teal' : 'bg-paper border border-black/10') + '">' + (on ? icon('Check', 13, '#fff', 2.5) : icon('Plus', 13, '#666')) + '</div></div>' +
            '<div class="p-5"><div class="font-medium text-[14.5px] mb-1">' + esc(a.name) + '</div><div class="text-[12px] text-ink-3 leading-relaxed mb-3">' + esc(a.desc) + '</div><div class="text-[14px] font-medium">' + fmt(a.price) + '</div></div></button>';
        }).join('') + '</div></div>';
    }

    function pillHTML(icn, label, value, on) {
      return '<div class="flex items-center gap-2 min-w-0 ' + (on ? 'text-ink' : 'text-ink-3') + '">' +
        '<div class="w-7 h-7 rounded-full grid place-items-center ' + (on ? 'bg-teal/10' : 'bg-black/[0.04]') + '">' + icon(icn, 12, on ? '#D8372D' : '#BCBCBC') + '</div>' +
        '<div class="min-w-0"><div class="text-[9.5px] uppercase tracking-wider text-ink-3 leading-none">' + label + '</div><div class="text-[12.5px] truncate max-w-[160px]">' + esc(value) + '</div></div></div>';
    }
    function barHTML() {
      var accN = st.acc.length;
      var canNext = (st.step === 1 && st.system) || (st.step === 2 && st.faucet) || st.step === 3;
      return '<div class="fixed inset-x-0 bottom-0 z-30 border-t border-black/10 bg-paper/95" style="backdrop-filter:blur(12px)">' +
        '<div class="max-w-[1400px] mx-auto px-4 md:px-10 py-3 flex items-center gap-3 md:gap-6">' +
        '<div class="hidden md:flex items-center gap-5 flex-1 min-w-0">' +
        pillHTML('Package', 'System', st.system ? st.system.name : '—', !!st.system) +
        pillHTML('Wrench', 'Vandhane', st.faucet ? st.faucet.model : '—', !!st.faucet) +
        pillHTML('Plus', 'Tilbehør', accN ? accN + ' stk.' : '—', accN > 0) + '</div>' +
        '<div class="flex md:hidden flex-1 min-w-0 text-[12px] text-ink-3"><span class="truncate"><span class="text-ink font-medium">' + esc(st.system ? st.system.name : 'Vælg system') + '</span>' + (st.faucet ? ' · ' + esc(st.faucet.model) : '') + '</span></div>' +
        '<div class="text-right"><div class="text-[9.5px] uppercase tracking-wider text-ink-3">Total · Din samling</div><div class="font-display text-lg md:text-xl">' + fmt(total()) + '</div></div>' +
        '<div class="flex items-center gap-2">' +
        (st.step > 1 ? '<button data-back class="btn btn-ghost !py-2.5 !px-4 text-[13px]">' + icon('ArrowLeft', 14) + '<span class="hidden sm:inline">Tilbage</span></button>' : '') +
        (st.step < 3 ?
          '<button data-next class="btn btn-primary !py-2.5 !px-5 text-[13px]" ' + (canNext ? '' : 'style="opacity:0.4;pointer-events:none"') + '>Næste ' + icon('ArrowRight', 14, '#fff') + '</button>' :
          '<button data-checkout class="btn btn-primary !py-2.5 !px-5 text-[13px]" ' + (st.system && st.faucet ? '' : 'style="opacity:0.4;pointer-events:none"') + '>Gå til checkout ' + icon('ShoppingBag', 14, '#fff') + '</button>') +
        '</div></div></div>';
    }

    function render() {
      stepsEl.innerHTML = stepsHTML();
      root.innerHTML = st.step === 1 ? step1HTML() : st.step === 2 ? step2HTML() : step3HTML();
      barEl.innerHTML = barHTML();
    }

    function pickSystem(sys) {
      if (st.system && st.faucet && st.system.id !== sys.id) {
        var next = faucetsForSystem(sys);
        if (!next.filter(function (f) { return f.id === st.faucet.id; }).length) {
          openWarning({
            title: 'Ny vandhane skal vælges',
            body: st.faucet.model + ' er ikke kompatibel med ' + sys.name + '. Vi nulstiller dit hane-valg så du kan vælge en kompatibel model.',
            actions: [
              { label: 'Fortsæt', onClick: function () { st.system = sys; st.faucet = null; st.step = 2; st.f2 = { series: 'Alle', spout: 'Alle', color: 'Alle' }; render(); scrollTop(); } },
              { label: 'Annullér' },
            ],
          });
          return;
        }
      }
      st.system = sys; st.step = 2; st.f2 = { series: 'Alle', spout: 'Alle', color: 'Alle' };
      st.compare = st.compare.filter(function (id) { return faucetsForSystem(sys).filter(function (f) { return f.id === id; }).length; });
      render(); scrollTop();
    }

    document.getElementById('configurator').addEventListener('click', function (e) {
      var t = function (attr) { var el = e.target.closest('[' + attr + ']'); return el ? el.getAttribute(attr) : null; };
      var v;
      if ((v = t('data-faucet-details'))) { e.stopPropagation(); openFaucetModal(byFaucetId(v), function (f) { st.faucet = f; render(); }); return; }
      if ((v = t('data-details'))) { openSystemModal(bySysId(v), pickSystem); return; }
      if ((v = t('data-filter'))) {
        if (st.filters.indexOf(v) === -1 && v === 'flavor') {
          st.filters.push(v);
          openWarning({ title: 'Saftevand kræver Infinity+', body: 'Saftevand-funktionen findes udelukkende på vores topmodel Infinity+. Vi har derfor indsnævret listen til Infinity+.', actions: [{ label: 'Forstået' }] });
        } else if (st.filters.indexOf(v) === -1) st.filters.push(v);
        else st.filters = st.filters.filter(function (x) { return x !== v; });
        if (st.system && !systemsMatching(st.filters).filter(function (m) { return m.id === st.system.id; }).length) { st.system = null; st.faucet = null; }
        render(); return;
      }
      if (e.target.closest('[data-reset-filters]')) { st.filters = []; render(); return; }
      if ((v = t('data-pick-sys'))) { pickSystem(bySysId(v)); return; }
      if ((v = t('data-pick-faucet'))) { st.faucet = byFaucetId(v); render(); return; }
      if ((v = t('data-cmp'))) {
        if (st.compare.indexOf(v) !== -1) st.compare = st.compare.filter(function (x) { return x !== v; });
        else if (st.compare.length >= 3) { openWarning({ title: 'Maks 3 i sammenligning', body: 'Du kan sammenligne op til 3 vandhaner ad gangen. Fjern én, før du tilføjer en ny.', actions: [{ label: 'OK' }] }); return; }
        else st.compare.push(v);
        render(); return;
      }
      if (e.target.closest('[data-open-cmp]')) { openCompareModal(st.compare, { onSelect: function (f) { st.faucet = f; render(); } }); return; }
      if (e.target.closest('[data-clear-cmp]')) { st.compare = []; render(); return; }
      if ((v = t('data-f2'))) { var p = v.split(':'); st.f2[p[0]] = p.slice(1).join(':'); render(); return; }
      if ((v = t('data-acc'))) { st.acc = st.acc.indexOf(v) !== -1 ? st.acc.filter(function (x) { return x !== v; }) : st.acc.concat(v); render(); return; }
      if (e.target.closest('[data-next]')) { if (st.step === 1 && st.system) st.step = 2; else if (st.step === 2 && st.faucet) st.step = 3; render(); scrollTop(); return; }
      if (e.target.closest('[data-back]')) { if (st.step > 1) { st.step--; render(); scrollTop(); } return; }
      if (e.target.closest('[data-checkout]')) {
        var ids = [st.system && st.system.variantId, st.faucet && st.faucet.variantId]
          .concat(U.accessories.filter(function (a) { return st.acc.indexOf(a.id) !== -1; }).map(function (a) { return a.variantId; }));
        addToCart(ids, openCartDrawer);
        return;
      }
    });
    render();
  }

  /* ================= KATALOGSIDE-HOOKS ================= */
  document.addEventListener('click', function (e) {
    var el;
    if ((el = e.target.closest('[data-open-system]'))) {
      var s = U.systems.filter(function (x) { return x.name === el.getAttribute('data-open-system'); })[0];
      if (s) { e.preventDefault(); openSystemModal(s, null); }
    } else if ((el = e.target.closest('[data-open-faucet]'))) {
      var f = U.faucets.filter(function (x) { return x.model === el.getAttribute('data-open-faucet'); })[0];
      if (f) { e.preventDefault(); openFaucetModal(f, null); }
    } else if ((el = e.target.closest('[data-open-acc]'))) {
      var a = U.accessories.filter(function (x) { return x.name === el.getAttribute('data-open-acc'); })[0];
      if (a) { e.preventDefault(); openAccessoryModal(a); }
    }
  });

  /* ================= SAMMENLIGN-SEKTION (forside) — systemvælger ================= */
  var cmpSec = document.querySelector('[data-compare-picker]');
  if (cmpSec) {
    var picked = ['Classic', 'Sparkle', 'Infinity+'];
    var pickerWrap = cmpSec.querySelector('[data-picker-buttons]');
    var names = [];
    cmpSec.querySelectorAll('[data-sys-col]').forEach(function (el) {
      var n = el.getAttribute('data-sys-col');
      if (names.indexOf(n) === -1) names.push(n);
    });
    function applyCmp() {
      cmpSec.querySelectorAll('[data-sys-col]').forEach(function (el) {
        el.style.display = picked.indexOf(el.getAttribute('data-sys-col')) !== -1 ? '' : 'none';
      });
      if (pickerWrap) pickerWrap.innerHTML = names.map(function (n) {
        var on = picked.indexOf(n) !== -1;
        return '<button data-pick-cmp="' + esc(n) + '" class="px-3 py-1.5 rounded-full text-[12px] ' + (on ? 'bg-ink text-paper' : 'bg-white text-ink-2 border border-black/5') + '">' + (on ? '<span class="inline-block w-2 h-2 rounded-full mr-2 align-middle" style="background:var(--tweak-accent)"></span>' : '') + esc(n) + '</button>';
      }).join('');
    }
    cmpSec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pick-cmp]');
      if (!b) return;
      var n = b.getAttribute('data-pick-cmp');
      if (picked.indexOf(n) !== -1) { if (picked.length > 1) picked = picked.filter(function (x) { return x !== n; }); }
      else { if (picked.length >= 4) picked.shift(); picked.push(n); }
      applyCmp();
    });
    applyCmp();
  }
})();
